import styled from 'styled-components';

export const CheckIconWrapper = styled.div<{ type: string }>`
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.border.radius['2xlarge']}px;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing['2']}px;
  background: ${({ theme, type }) =>
    type === 'positive'
      ? theme.colors.feedback.background.positive.subtle
      : type === 'neutral'
      ? theme.colors.feedback.background.neutral.subtle
      : theme.colors.feedback.background.negative.subtle};
`;

export const MultiBenefitValueRow = styled.div<{ isHovered: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing['4']}px ${theme.spacing['6']}px`};
  transition: background-color 0.2s ease-in-out;
  background-color: ${({ theme, isHovered }) =>
    isHovered
      ? theme.colors.interactive.background.negative.faded
      : theme.colors.surface.background.gray.moderate};
`;

export const SelectAmountContainer = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing['3']}px;
  padding: ${({ theme }) => `${theme.spacing['2']}px ${theme.spacing['3']}px`};
  background-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colors.interactive.background.primary.faded
      : theme.colors.surface.background.gray.moderate};
  border: 1px solid
    ${({ theme, isSelected }) =>
      isSelected
        ? theme.colors.interactive.border.primary.default
        : theme.colors.surface.border.gray.muted};
  border-radius: ${({ theme }) => theme.border.radius.small}px;
  transition: all 0.2s ease-in-out;
`;

export const UserIconContainer = styled.div`
  border-radius: ${({ theme }) => theme.border.radius['2xlarge']}px;
  background-color: ${({ theme }) => theme.colors.surface.background.sea.subtle};
  padding: ${({ theme }) => theme.spacing['3']}px;
`;
